import { render, staticRenderFns } from "./PostReply.vue?vue&type=template&id=71c2cc4b&scoped=true"
import script from "./PostReply.vue?vue&type=script&lang=js"
export * from "./PostReply.vue?vue&type=script&lang=js"
import style0 from "./PostReply.vue?vue&type=style&index=0&id=71c2cc4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2cc4b",
  null
  
)

export default component.exports